import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import SearchableSelect from '../common/SearchableSelect';
import axios from 'axios';

const AddTransactionModal = ({ show, onHide, projectId, accounts, payees, classes, fetchTransactions, plTypes, bsTypes }) => {
  const [formData, setFormData] = useState({
    date: new Date().toISOString().split('T')[0],
    description: '',
    amount: '',
    fromAccount: '',
    toAccount: '',
    payeeId: '',
    classId: '',
    category: 'Uncategorized',
    note: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const targetAcc = accounts.find(a => a._id === formData.toAccount);
      await axios.post(`/api/projects/${projectId}/transactions`, {
        ...formData,
        category: targetAcc ? targetAcc.name : 'Uncategorized'
      });
      fetchTransactions();
      onHide();
      setFormData({
        date: new Date().toISOString().split('T')[0],
        description: '',
        amount: '',
        fromAccount: '',
        toAccount: '',
        category: 'Uncategorized',
        note: ''
      });
    } catch (err) {
      console.error(err);
      alert('Error creating transaction');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Add Manual Transaction</Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <div className="row">
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label className="font-weight-bold small text-muted">Date</Form.Label>
                <Form.Control type="date" value={formData.date} onChange={e => setFormData({...formData, date: e.target.value})} required />
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label className="font-weight-bold small text-muted">Amount</Form.Label>
                <Form.Control type="number" step="0.01" value={formData.amount} onChange={e => setFormData({...formData, amount: e.target.value})} required placeholder="0.00" />
              </Form.Group>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <Form.Group className="mb-3">
                <Form.Label className="font-weight-bold small text-muted">Description</Form.Label>
                <Form.Control type="text" value={formData.description} onChange={e => setFormData({...formData, description: e.target.value})} required placeholder="Enter description..." />
              </Form.Group>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label className="font-weight-bold small text-muted">Source Account</Form.Label>
                <SearchableSelect 
                  options={[
                    { value: '', label: '-- Select Source --' },
                    ...accounts.filter(a => ['Bank', 'Credit Card'].includes(a.type)).map(a => ({ value: a._id, label: a.name, sublabel: a.type }))
                  ]}
                  value={formData.fromAccount}
                  onChange={e => setFormData({...formData, fromAccount: e.target.value})}
                  placeholder="-- Select Source --"
                />
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label className="font-weight-bold small text-muted">Category / Target Account</Form.Label>
                <SearchableSelect 
                  options={[
                    { value: '', label: '-- Select Category/Account --' },
                    ...accounts.map(a => ({ value: a._id, label: a.name, sublabel: a.type }))
                  ]}
                  value={formData.toAccount}
                  onChange={e => setFormData({...formData, toAccount: e.target.value})}
                  placeholder="-- Select Category/Account --"
                />
              </Form.Group>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label className="font-weight-bold small text-muted">Payee</Form.Label>
                <SearchableSelect 
                  options={[
                    { value: '', label: '-- None --' },
                    ...(payees ? payees.filter(p => p.isActive).map(p => ({ value: p._id, label: p.name, sublabel: p.type })) : [])
                  ]}
                  value={formData.payeeId}
                  onChange={e => setFormData({...formData, payeeId: e.target.value})}
                  placeholder="-- None --"
                />
              </Form.Group>
            </div>
            <div className="col-md-6">
              <Form.Group className="mb-3">
                <Form.Label className="font-weight-bold small text-muted">Class</Form.Label>
                <SearchableSelect 
                  options={[
                    { value: '', label: '-- None --' },
                    ...(classes ? classes.filter(c => c.isActive).map(c => ({ value: c._id, label: c.name })) : [])
                  ]}
                  value={formData.classId}
                  onChange={e => setFormData({...formData, classId: e.target.value})}
                  placeholder="-- None --"
                />
              </Form.Group>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <Form.Group className="mb-0">
                <Form.Label className="font-weight-bold small text-muted">Note</Form.Label>
                <Form.Control as="textarea" rows={2} value={formData.note} onChange={e => setFormData({...formData, note: e.target.value})} placeholder="Optional notes..." />
              </Form.Group>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>Cancel</Button>
          <Button variant="primary" type="submit" disabled={loading}>{loading ? 'Saving...' : 'Save Transaction'}</Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default AddTransactionModal;
